/**
 * Field synchronization module for traveller forms.
 * Syncs FirstName + LastName → FullName and DateOfBirth ↔ Birthday.
 */

/**
 * Setup field synchronization for a single traveller
 */
export function setupTravellerSync(travellerPrefix: string, contactPrefix: string) {
    const firstName = document.querySelector<HTMLInputElement>(`[name="${travellerPrefix}.FirstName"]`);
    const lastName = document.querySelector<HTMLInputElement>(`[name="${travellerPrefix}.LastName"]`);
    const fullName = document.querySelector<HTMLInputElement>(`[name="${contactPrefix}.FullName"]`);

    if (firstName && lastName && fullName) {
        const syncFullName = () => {
            const fn = (firstName.value || '').trim();
            const ln = (lastName.value || '').trim();
            fullName.value = `${fn} ${ln}`.trim();
        };
        firstName.addEventListener('input', syncFullName);
        lastName.addEventListener('input', syncFullName);
    }

    const dateOfBirth = document.querySelector<HTMLInputElement>(`[name="${travellerPrefix}.DateOfBirth"]`);
    const birthday = document.querySelector<HTMLInputElement>(`[name="${contactPrefix}.Birthday"]`);

    if (dateOfBirth && birthday) {
        dateOfBirth.addEventListener('change', () => { birthday.value = dateOfBirth.value; });
        birthday.addEventListener('change', () => { dateOfBirth.value = birthday.value; });
    }
}
